module.exports = __webpack_public_path__ + "img/consult_info1.ff823819.png";